/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { postSeb } from '../fn/tests/post-seb';
import { PostSeb$Params } from '../fn/tests/post-seb';

@Injectable({ providedIn: 'root' })
export class ApiTestsService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postTestsSeb()` */
  static readonly PostTestsSebPath = '/Tests/seb';

  /**
   * post-tests-seb.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postSeb()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  postSeb$Response(params?: PostSeb$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postSeb(this.http, this.rootUrl, params, context);
  }

  /**
   * post-tests-seb.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postSeb$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  postSeb(params?: PostSeb$Params, context?: HttpContext): Observable<void> {
    return this.postSeb$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
